import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';

export const key = ['GET_USER_ACCESS_TOKEN'];

export const useGetUserAccessToken = (code: string) => {
  return useQuery({
    queryKey: [...key, code],
    queryFn: async () => {
      const { data } = await axiosInstance.post('/api/member/exchange-token', {
        code
      });

      if (data.token) {
        localStorage.setItem('token', data.token);
      }
      return data;
    },
    retry: false,
    enabled: !!code,
    staleTime: Infinity,
    cacheTime: Infinity
  });
};
